import loginBanner from "@/assets/login-banner.png";
import apnaSanatan from "@/assets/apna-sanatan.svg";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import Button from "@/components/Button";
import { successToast } from "@/lib/toast";

export default function LoginPage() {
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { status, login } = useAuth();
  const [searchParams, _] = useSearchParams();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await login(mobile, password);
    if (!success) return;
    successToast("Login Successful");
    const callbackUrl = searchParams.get("callback");
    navigate(callbackUrl || "/", { replace: true, viewTransition: true });
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      setMobile(value);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white p-4">
      <div className="md:w-full bg-white rounded-2xl  flex flex-col md:flex-row items-center">
        {/* Left Side Image */}
        <div className="md:w-1/2 relative p-4 hidden md:block">
          <img
            src={loginBanner}
            alt="Sanatan Ka Ghar"
            className="aspect-[1.1] w-full object-cover rounded-2xl"
          />
        </div>

        {/* Right Side Form */}
        <div className="md:w-1/2  max-w-md flex flex-col justify-center items-center md:ml-auto md:mr-auto">
          <img src={apnaSanatan} alt="Apna Sanatan" className="h-32 mb-4" />
          <h2 className="text-2xl md:text-4xl font-semibold font-primary flex items-center">
            Welcome<span className="ml-2">🙏</span>
          </h2>
          <p className=" text-md md:text-lg text-gray-500 mt-1 text-center mb-4">
            {/* <span className="text-primary font-medium">
              Astrologer partner!
            </span>{" "} */}
            Please sign in to continue
          </p>

          <form className="w-full mt-2" onSubmit={handleSubmit}>
            <div className="mb-2">
              <label className="block text-gray-900 text-base mb-1">
                Phone no.
              </label>
              <input
                value={mobile}
                onChange={handleMobileChange}
                type="tel"
                inputMode="numeric"
                placeholder="Your mobile no."
                className="w-full px-4 py-3 border-gray-300 text-md bg-slate-50 rounded-xl text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
              />
            </div>
            <div className="mb-1">
              <label className="block text-gray-900 text-base mb-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                className="w-full px-4 py-2 border bg-slate-50 rounded-xl text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
              />
            </div>
            <div className="text-right text-sm text-primary mb-2">
              <a href="#" className="hover:underline">
                Forgot Password?
              </a>
            </div>
            <Button
              type="submit"
              loading={status.loading}
              title="Sign in"
              variant="primary"
              onClick={handleSubmit}
            />
          </form>
        </div>
      </div>
    </div>
  );
}
